const KEY = "rceg_leads_v1";

const safeParse = (value, fallback) => {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const getLeads = () => {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(KEY);
  const leads = safeParse(raw, []);
  return Array.isArray(leads) ? leads : [];
};

export const addLead = (lead) => {
  if (typeof window === "undefined") return;

  const current = getLeads();
  const next = [
    {
      id: crypto?.randomUUID ? crypto.randomUUID() : String(Date.now()),
      createdAt: new Date().toISOString(),
      ...lead,
    },
    ...current,
  ];

  window.localStorage.setItem(KEY, JSON.stringify(next));
};

export const clearLeads = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(KEY);
};
